module.exports = __webpack_public_path__ + "static/img/200211.411af201.png";